"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UISplitLayout;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("../layout/UIBox"));

var _Style = require("../core/Style");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: -", ";\n  margin-top: -", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: ", ";\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = (0, _styledComponents.default)(function (props) {
  var __orientation = props.orientation,
      rest = (0, _objectWithoutProperties2.default)(props, ["orientation"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UISplitLayout__Outer",
  componentId: "sc-1dj44dp-0"
})(_templateObject(), (0, _Style.remCalc)(_sizes.BASE_SPACING_X));
var Inner = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "UISplitLayout__Inner",
  componentId: "sc-1dj44dp-1"
})(_templateObject2(), (0, _Style.remCalc)(_sizes.BASE_SPACING_X), (0, _Style.remCalc)(_sizes.BASE_SPACING_Y));
var getSlotPadding = "\n  padding-left: " + (0, _Style.remCalc)(_sizes.BASE_SPACING_X) + ";\n  padding-top: " + (0, _Style.remCalc)(_sizes.BASE_SPACING_Y) + ";\n";
var PrimarySlot = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "UISplitLayout__PrimarySlot",
  componentId: "sc-1dj44dp-2"
})(_templateObject3(), getSlotPadding);
var SecondarySlot = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "UISplitLayout__SecondarySlot",
  componentId: "sc-1dj44dp-3"
})(_templateObject4(), getSlotPadding);

function UISplitLayout(props) {
  var InnerWrapper = props.InnerWrapper,
      orientation = props.orientation,
      Primary = props.Primary,
      primaryContent = props.primaryContent,
      primaryClassName = props.primaryClassName,
      primaryWidth = props.primaryWidth,
      reverseOrder = props.reverseOrder,
      Secondary = props.Secondary,
      secondaryContent = props.secondaryContent,
      secondaryClassName = props.secondaryClassName,
      secondaryWidth = props.secondaryWidth,
      rest = (0, _objectWithoutProperties2.default)(props, ["InnerWrapper", "orientation", "Primary", "primaryContent", "primaryClassName", "primaryWidth", "reverseOrder", "Secondary", "secondaryContent", "secondaryClassName", "secondaryWidth"]);
  var computedDirection = orientation === 'horizontal' ? 'row' : 'column';
  return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
    orientation: orientation
  }), _react.default.createElement(InnerWrapper, {
    direction: computedDirection,
    justify: "between",
    wrap: "wrap"
  }, _react.default.createElement(Primary, {
    className: primaryClassName,
    basis: primaryWidth,
    orientation: orientation,
    order: reverseOrder ? 1 : 0
  }, primaryContent), _react.default.createElement(Secondary, {
    basis: secondaryWidth,
    className: secondaryClassName,
    orientation: orientation
  }, secondaryContent)));
}

UISplitLayout.propTypes = {
  InnerWrapper: RenderProp.getPropType(_UIFlex.default),
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  Primary: RenderProp.getPropType(_UIBox.default),
  primaryContent: _propTypes.default.node.isRequired,
  primaryClassName: _propTypes.default.string,
  primaryWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  reverseOrder: _propTypes.default.bool.isRequired,
  Secondary: RenderProp.getPropType(_UIBox.default),
  secondaryContent: _propTypes.default.node,
  secondaryClassName: _propTypes.default.string,
  secondaryWidth: _propTypes.default.number,
  width: _propTypes.default.number
};
UISplitLayout.defaultProps = {
  InnerWrapper: Inner,
  Primary: PrimarySlot,
  Secondary: SecondarySlot,
  orientation: 'horizontal',
  reverseOrder: false
};
UISplitLayout.displayName = 'UISplitLayout';
module.exports = exports.default;